<template>
    <div
        class="tw-sticky tw-top-0 tw-z-10 tw-text-purple-50 tw-shadow-sm tw-py-0 tw-px-4 tw-h-50px tw-flex tw-justify-center tw-items-center"
        :style="{
            backgroundColor: teamSettings.navbarColor || '#211941',
        }"
    >
        <span class="tw-w-1/2">
            <a href="#/profile" class="tw-hidden md:tw-inline-block">
                <img
                    data-test-id="nav-bar-logo-image"
                    :src="teamSettings.logo || '/img/leapsome.png'"
                    class="tw-max-h-6"
                    :alt="teamSettings.name || 'Leapsome'"
                />
            </a>
        </span>

        <span
            class="tw-space-x-2 tw-flex-shrink-0 tw-select-none tw-flex tw-items-center tw-justify-center"
        >
            <span
                v-if="!loading && state === constants.SESSION_STATES.ACTIVE"
                v-b-popover.hover.bottom="
                    isFullExportEnabled
                        ? $t('surveys.participate.fullExportEnabledHelp')
                        : isAnonymousSurvey
                        ? $t('surveys.participate.nameIsNotVisible')
                        : $t('surveys.participate.nameIsVisible')
                "
                class="tw-cursor-help"
                :data-test-id="
                    isAnonymousSurvey ? 'survey-anonymous-hint' : 'survey-not-anonymous-hint'
                "
            >
                <template v-if="isFullExportEnabled && isAnonymousSurvey">
                    <i class="fa fa-shield-check tw-mr-1" />
                    <i18n path="surveys.participate.anonymityHint" for="value">
                        <span class="tw-font-bold">{{ $t("surveys.participate.anonymous") }}</span>
                    </i18n>
                    ({{ $t("surveys.participate.fullExportEnabled") }})
                </template>

                <template v-else-if="isAnonymousSurvey">
                    <i class="fa fa-shield-check tw-mr-1" />
                    <i18n path="surveys.participate.anonymityHint" for="value">
                        <span class="tw-font-bold">{{ $t("surveys.participate.anonymous") }}</span>
                    </i18n>
                </template>

                <template v-else>
                    <i class="fa fa-user tw-mr-1" />
                    <i18n path="surveys.participate.anonymityHint" for="value">
                        <span
                            ><span class="tw-font-bold">{{ $t("surveys.participate.not") }}</span>
                            {{ $t("surveys.participate.anonymous") }}</span
                        >
                    </i18n>
                </template>
            </span>

            <span
                v-if="isPreview"
                class="tw-uppercase tw-text-xs tw-font-bold tw-text-indigo-50 tw-inline-block tw-px-2 tw-py-1 tw-bg-indigo-900 tw-rounded"
            >
                {{ $t("surveys.participate.preview") }}
            </span>
        </span>

        <span class="tw-w-1/2 tw-text-right">
            <a
                href="#/profile"
                class="tw-text-white hover:tw-text-indigo-500 focus:tw-text-indigo-500"
                data-test-id="survey-close-icon"
                @click.prevent="onClose"
            >
                <i class="fa fa-times" />
                <span class="tw-sr-only">{{ $t("surveys.participate.btnCloseSurvey") }}</span>
            </a>
        </span>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import { SESSION_STATES } from "@/config/survey-answer-session";

export default {
    data() {
        return {
            constants: Object.freeze({
                SESSION_STATES,
            }),
        };
    },
    computed: {
        ...mapGetters({
            teamSettings: "users/current/teamSettings",
            isAnonymousSurvey: "surveys/answerSession/isAnonymousSurvey",
            isFullExportEnabled: "surveys/answerSession/isFullExportEnabled",
            loading: "surveys/answerSession/loading",
            state: "surveys/answerSession/state",
        }),
        isPreview() {
            return this.$route.params?.notificationId === "preview";
        },
    },
    methods: {
        onClose() {
            if (this.$route.params?.notificationId === "preview") {
                this.$router.replace(`/surveys/edit/${this.$route.params?.surveyId}/questions`);
                return;
            }

            this.$router.push("/profile");
        },
    },
};
</script>

<style scoped>
.tw-h-50px {
    height: 50px;
}
</style>
